export default __webpack_public_path__ + "static/media/logout.1cc00e9d.svg";